import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiBadgeComponent, type UiBadgeTone } from '@nexus/frontend-shared-ui';
import type { WishlistStatusPillTone } from '../../types/wishlist-status-pill-tone.type';

@Component({
  selector: 'wishlist-status-pill',
  imports: [UiBadgeComponent],
  templateUrl: './wishlist-status-pill.component.html',
  styleUrl: './wishlist-status-pill.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistStatusPillComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly tone: InputSignal<WishlistStatusPillTone> = input<WishlistStatusPillTone>('neutral');
  public readonly iconLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly ariaLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly compact: InputSignal<boolean> = input<boolean>(false);

  protected readonly badgeTone: Signal<UiBadgeTone> = computed((): UiBadgeTone => {
    const tone: WishlistStatusPillTone = this.tone();

    return tone === 'info' ? 'accent' : tone;
  });
  protected readonly accessibleLabel: Signal<string | null> = computed(
    (): string | null => this.ariaLabel() ?? this.label(),
  );
  protected readonly hasIcon: Signal<boolean> = computed((): boolean => this.iconLabel() !== null);
}
